// src/hooks/useMeta.js
import { useEffect } from 'react';

export default function useMeta({ title, description, canonical, og = {} }) {
    useEffect(() => {
        if (title) document.title = title;

        // Meta: description
        if (description) {
            let metaDesc = document.querySelector("meta[name='description']");
            if (!metaDesc) {
                metaDesc = document.createElement("meta");
                metaDesc.name = "description";
                document.head.appendChild(metaDesc);
            }
            metaDesc.content = description;
        }

        // Link: canonical
        if (canonical) {
            let link = document.querySelector("link[rel='canonical']");
            if (!link) {
                link = document.createElement("link");
                link.rel = "canonical";
                document.head.appendChild(link);
            }
            link.href = canonical;
        }

        // Open Graph (og:) tags
        Object.entries(og).forEach(([property, content]) => {
            if (!content) return;
            let metaOg = document.querySelector(`meta[property='og:${property}']`);
            if (!metaOg) {
                metaOg = document.createElement("meta");
                metaOg.setAttribute("property", `og:${property}`);
                document.head.appendChild(metaOg);
            }
            metaOg.content = content;
        });

    }, [title, description, canonical, og]);
}
